import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import DatePicker from 'material-ui/DatePicker';
import moment from 'moment';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
import $ from 'jquery'
import '../../stylesheet/transfer.css'
import html2canvas from 'html2canvas';
import * as JSpdf from 'jspdf'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../loader/loader.jsx'
import * as actions from '../../actions/actions.jsx'
import { connect } from "react-redux";
// import Loader from '../loader/loader.jsx'
import s from '../../services/allservices.jsx'

const styles = {
    block: {
        maxWidth: 250,
    },
    radioButton: {
        marginBottom: 5,
        marginTop: 5,
        width: "33%",
        display: "inline"
    },
    blockmargin: {
        marginBottom: 10,
        marginRight: 10
    },
    labelStyle: {
        padding: 0,
        color: "#fff",
        marginTop: 20
    },
    inputStle: {
        marginRight: 5,
        marginTop: 10
    },
    groupstyle: {
        display: "flex",
        width: "100%"
    },
    radioIcon: {
        fill: "#333"
    },
    calendarStyle: {
        // backgroundColor:"#333"
    },
    calendarTextStyle: {
        color: "#fff",
        // backgroundColor:"#333"
    }
};
const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        cardState: state.getCardReducer.cardState,
        transHistory: state.getTransferHistory.transHistory,
        rowData: state.storeRowDetail.rowData
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
        fetchTransferHistory(cardDetailId, startDate, endDate, status) {

            dispatch(
                actions.getTransferHistory(cardDetailId, startDate, endDate, status)
            )
        },
        storeHistoryRowData(state) {
            dispatch(
                actions.stoteRowDetail(state)
            )
        }
    })

const JSEncrypt = window.JSEncrypt
class TransferHistory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardAccount: 1,
            show: "P",
            historyType: '',
            statementFromDate: "",
            statementTodDate: "",
            status: '',
            loader: true,
            selectedCard: [],
            disabled: true,
            todate: true,
            controlledDate: null,
            cardInUse: [],
            quickLoad: false,
        }
    }

    handleSelect = (event, index, value) => {
        const { cardState } = this.props
        for (let i = 0; i < cardState.body.length; i++) {
            if (cardState.body[i].cardDetailsId === value) {
                this.setState({
                    cardInUse: cardState.body[i]
                })
            }
        }
        this.setState({ cardAccount: value }, () => {
            for (let i = 0; i < cardState.body.length; i++) {
                if (this.state.cardDetailsId === cardState.body[i].cardDetailsId) {

                    this.setState({

                        selectedCard: cardState.body[i]
                    }, () => {
                        this.setState({
                            loader: true
                        })
                        this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)

                    }, () => {
                        this.setState({
                            loader: false
                        })
                    })
                }
            }
        });

        // this.setState({ cardAccount: value }, () => {
        //     loader: true
        //     this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)
        // });

    }
    componentWillReceiveProps(nextProps) {

        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    loader: false,

                    selectedCard: nextProps.cardState.body[0]
                }, () => {

                }
                )
            }
        } catch (e) {

        }

    }
    handleDateChange = (date) => {
        this.setState({
            controlledDate: date,
        });
        return date;
    };
    handleSelect1 = (event, index, value) => this.setState({ show: value }, () => {
        loader: true
        this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)
    },
        this.setState({
            loader: false
        })
    );
    handleFromDate = (e, date) => {

        this.setState({
            statementFromDate: this.converDate(date)
            // dob: this.converDate(date)
        }, () => {

            if (this.state.statementFromDate.length !== 0 && this.state.statementTodDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })
    }
    handleToDate = (e, date) => {

        this.setState({
            statementTodDate: this.converDate(date)

            // dob: this.converDate(date)
        }, () => {

            if (this.state.statementFromDate.length !== 0 && this.state.statementTodDate.length !== 0) {
                this.setState({
                    disabled: false

                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        }
        )
    }
    converDate(date) {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [


            (mm > 9 ? '' : '0') + mm,
            (dd > 9 ? '' : '0') + dd,
            date.getFullYear()
        ].join('/');
    }

    handleChangeMinDate = (event, date) => {
        this.setState({
            statementFromDate: this.converDate(date),
        });
    };
    componentDidUpdate(prevProps) {

    }
    removetodate = () => {
        this.setState({
            todate: true
        })
    }
    handleChangeMaxDate = (event, date) => {
        this.setState({
            statementTodDate: date,
        });
    }
    // handleHistory = () => {
    //     if (Date.parse(this.state.statementTodDate) <= Date.parse(this.state.statementFromDate)) {
    //         this.setState({
    //             todate: false,
    //         })
    //     }
    //     else {


    //         this.setState({
    //             applicationId: "gmcabs",
    //             cardDetailsId: this.state.cardAccount,
    //             historyType: "P",
    //             statementFromDate: this.state.statementFromDate,
    //             statementTodDate: this.state.statementTodDate,
    //             status: "P"
    //         }, () => {
    //             this.setState({
    //                 loader: true
    //             })
    //             this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)

    //         }, () => {
    //             this.setState({
    //                 loader: false
    //             })
    //         })
    //     }
    // }
    handleHistory = () => {

        if (Date.parse(this.state.statementTodDate) < Date.parse(this.state.statementFromDate)) {
            this.setState({
                todate: false,
            })
        }
        else {

            this.setState({
                applicationId: "gmcabs",
                cardDetailsId: this.state.cardAccount,
                historyType: "P",
                statementFromDate: this.state.statementFromDate,
                statementTodDate: this.state.statementTodDate,
                status: "P"

            }, () => {
                this.setState({
                    loader: true
                })
                this.props.fetchTransferHistory(this.state.cardAccount, this.state.statementFromDate, this.state.statementTodDate, this.state.show)
            }, () => {
                this.setState({
                    loader: false
                })
            })
        }
    }

    removetodate = () => {
        this.setState({
            todate: true
        })
    }
    formatDate = (date) => {
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();
        return [

            (dd > 9 ? '' : '0') + dd,
            (mm > 9 ? '' : '0') + mm,
            date.getFullYear()
        ].join('/');
    }
    handleCardClick(state) {
        this.setState({
            selectedCard: state
        }, () => {
            this.setState({
                useClass: "tile"
            })
            document.getElementById("tilediv").style.display = "block"
        })
    }
    handleDownload() {
        this.setState({
            quickLoad: true,
         
        })
        const input = document.getElementById('TransferdivPrint');
        html2canvas(input)
            .then((canvas) => {
                const img = canvas.toDataURL('image/png');
                //const pdf = new jsPDF('p', 'mm');
                //let img = pdf.addImage(imgData, 'JPEG', 0, 0);
                var imgWidth = 210;
                var pageHeight = 295;
                var imgHeight = canvas.height * imgWidth / canvas.width;
                var heightLeft = imgHeight;

                const pdf = new JSpdf('p', 'mm')
                var position = 0;

                pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                    position = heightLeft - imgHeight;
                    pdf.addPage();
                    pdf.addImage(img, 'PNG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                }
                // pdf.output('dataurlnewwindow');
                pdf.save("download.pdf");
            });
            setTimeout(() => {
                this.setState({ quickLoad: false})
            }, 2000)
    }

    componentDidMount() {
        this.setState({
            cardAccount: this.props.cardState.body[0].cardDetailsId,
            cardInUse: this.props.cardState.body[0]
        })
        this.setState({
            loader: true
        })
        this.props.fetchTransferHistory(this.props.cardState.body[0].cardDetailsId, this.state.statementFromDate, this.state.statementTodDate, this.state.show)
        this.setState({
            loader: false
        })
        // .then(response => {
        //     if (response.status === 200 || response.status === 201 || response.status === 204) {
        //         this.setState({
        //             loader: false
        //         })                   
        //     } else {
        //         toast.error(response.headers.get('message'), {
        //             position: "top-right",
        //             draggablePercent: 60,
        //             autoClose: 3000,
        //             hideProgressBar: false,
        //             closeOnClick: true,
        //             pauseOnHover: true,
        //             draggable: false
        //         });
        //         this.setState({
        //             loader: false
        //         })

        //     }
        // })

        // document.getElementById("errordiv").style.display = response.headers.get('message');


    }
    handleDownload1() {
        const input = document.getElementById('recurringdivPrint');
        html2canvas(input)
            .then((canvas) => {
                const imgData = canvas.toDataURL('image/png');
                const pdf = new JSpdf();
                pdf.addImage(imgData, 'JPEG', 0, 0);
                // pdf.output('dataurlnewwindow');
                pdf.save("download.pdf");
            })
            ;
    }
    handleView(state) {

        this.props.storeHistoryRowData(state)
        localStorage.setItem('rowdata', JSON.stringify(state))

    }
    render() {
        const { cardState, transHistory, rowData } = this.props
        const { cardAccount, statementFromDate, selectedCard, todate, statementTodDate, useClass, cardInUse } = this.state

        return (
            <div>
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container transfer" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div>
                        <div className="modal fade" id="editview">
                            <div className="modal-dialog modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header" style={{ backgroundColor: "#333" }}>
                                        <h4 className="modal-title" style={{ color: "#fff" }}>
                                            Share Funds - View</h4>
                                        <button type="button" className="close" data-dismiss="modal" style={{ color: "#fff" }}>&times;</button>
                                    </div>


                                    <div className="modal-body">
                                        <div className="row">
                                            <div className="col-sm-12 " style={{ fontSize: "14px" }} >

                                                <div className="col-sm-12" >
                                                    <h5>Transfer Details</h5>
                                                </div>
                                                <div className="col-sm-12" >
                                                    <div className="row" style={{ marginTop: "10px" }}>

                                                        <div className=" col-sm-5  tilepadding">
                                                            <label className="tilecontent"> Transfer ID  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.transactionId}  </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className=" col-md-5  tilepadding">
                                                            <label className="tilecontent">Status </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.status} </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className=" col-md-5  tilepadding">
                                                            <label className="tilecontent">Card Account (From)  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.cardProgramId} {rowData.fromaccountNumber}  $ {rowData.balance} </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Card Account (To)  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">   </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Debit Amount </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">$ {rowData.amount}  </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Transfer Date  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.transferDate} </span><br />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-5  tilepadding">
                                                            <label className="tilecontent">Comments  </label>
                                                        </div>
                                                        <div className="col-md-7 text-left tilepadding">
                                                            <span className="tileheadername">{rowData.comments}  </span><br />
                                                        </div>
                                                    </div>
                                                    <div className=" offset-sm-4 col-sm-2" >
                                                        <RaisedButton
                                                            label="Close"
                                                            backgroundColor="#333"
                                                            labelColor="#fff"
                                                            data-dismiss="modal"
                                                            style={{ marginTop: "10px", backgroundColor: "#333 !important" }}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal" onClick={this.handleSubmit.bind(this)}>Submit</button>
                        </div> */}

                                </div>
                            </div>
                        </div>
                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "12px 0px", minHeight: "476px" }}>
                                <div className="col-sm-12">
                                    <div className="header-style">
                                        <h4>
                                            Transfer History
                                        </h4>
                                        <p>
                                            Search for the history of a specific transfer or view the history of all transfers from this screen. Find transfer account information to include where money was transferred from and to, amount transferred, type of transfer, date of transfer, and its status. In addition account information can be edited or cancelled.
                                        </p>
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="search-history">
                                        <div className="row">
                                            <div className="col-sm-4" style={{ marginTop: "38px" }}>
                                                <h5>Transfer History Search</h5>
                                            </div>
                                            {cardState.status === 200 && cardState.body.length !== 0 && selectedCard.length !== 0 &&
                                                <div className="col-sm-8">
                                                    <div className="row">
                                                        <div className="col-sm-12">
                                                            <div className="row">
                                                                <div className="col-sm-3" style={{ marginTop: "38px", marginLeft: "20px" }}>
                                                                    {selectedCard.cardProgramId}
                                                                </div>
                                                                <div className="col-sm-2 input-icon" >
                                                                    <img src={creditcardlogo} alt="" />
                                                                </div>


                                                                <div className="col-sm-6" >
                                                                    {cardState.body.length !== 0 &&
                                                                        <SelectField
                                                                            floatingLabelText="Card Account"
                                                                            onChange={this.handleSelect}
                                                                            className="input-width"
                                                                            name="cardAccount"
                                                                            value={cardAccount}
                                                                        >
                                                                            {cardState.body.map((value, i) =>
                                                                                <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                                            )}
                                                                        </SelectField>}
                                                                </div>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>}
                                        </div>
                                    </div>
                                </div>
                                {cardState.status === 200 &&
                                    <div className="col-sm-12" style={{ marginTop: "20px" }}>
                                        <div className="row">
                                            <div className="col-sm-4" style={{ marginTop: "21px" }}>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 input-icon" >
                                                        <i className="fa fa-calendar text-dark " aria-hidden="true"></i>
                                                    </div>
                                                    <div className="col-sm-10 nopadding" >
                                                        <DatePicker
                                                            hintText="From Date"
                                                            container="inline"
                                                            name="statementFromDate"
                                                            className="input-width"
                                                            formatDate={this.formatDate}
                                                            onChange={this.handleFromDate}
                                                            style={styles.calendarStyle}
                                                            maxDate={new Date()}
                                                            textFieldStyle={styles.calendarTextStyle}
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4" style={{ marginTop: "21px" }}>
                                                <div className="row input-group" >
                                                    <div className="col-sm-2 transferbutton" >
                                                        <i className="fa fa-calendar text-dark " aria-hidden="true" ></i>
                                                    </div>
                                                    <div className="col-sm-10 nopadding" >
                                                        <DatePicker hintText="To Date"
                                                            onChange={this.handleToDate}
                                                            container="inline"
                                                            name="statementTodDate"
                                                            formatDate={this.formatDate}
                                                            onFocus={this.removetodate}
                                                            maxDate={new Date()}
                                                            className="input-width"
                                                            onFocus={this.removetodate}
                                                            errorText={todate ? null : "To-date should not less than from-date."} />

                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-sm-4 nopadding">
                                                <div className="row">
                                                    <div className="col-sm-2 input-icon" >
                                                        <img src={creditcardlogo} alt="" />
                                                    </div>
                                                    <div className="col-sm-10" >

                                                        <SelectField
                                                            floatingLabelText="Transfer Status"
                                                            onChange={this.handleSelect1}
                                                            className="input-width"
                                                            name="show"
                                                            value={this.state.show}
                                                        >
                                                            {/* <MenuItem value={1} primaryText="Select transfer status" /> */}
                                                            <MenuItem value="P" primaryText="Processed" />
                                                            <MenuItem value="M" primaryText="Manual" />
                                                            <MenuItem value="C" primaryText="Cancelled" />
                                                            <MenuItem value="R" primaryText="Deferred" />


                                                        </SelectField>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>}
                                <div className="col-sm-12">
                                    <div className="offset-md-4 col-md-2 text-center">
                                        <RaisedButton
                                            label="Show"
                                            className="pull-right"
                                            disabled={this.state.disabled}
                                            // style={styles.button}
                                            backgroundColor="#333"
                                            labelColor="#fff"
                                            onClick={this.handleHistory}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="col-sm-12 " style={{ marginTop: "30px" }}>

                                    <div className="btn-pref btn-group btn-group-justified btn-group-sm transfer" role="group" aria-label="...">
                                        <div className="btn-group" role="group">
                                            <button type="button" id="stars" className="btn btn-secondary btn-sm" href="#tab1" data-toggle="tab" onClick={this.showdefault}>
                                                <div className="hidden-xs">Transfer History</div>
                                            </button>
                                        </div>
                                        <div className="btn-group" role="group">
                                            <button type="button" id="favorites" className="btn btn-default btn-sm" style={{ width: "95%" }} href="#tab2" data-toggle="tab" onClick={this.showcustomized}>
                                                <div className="hidden-xs">Recurring Transfer History </div>
                                            </button>
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-sm-12 transfer" style={{ marginTop: "30px" }}>
                                    <div className="pull-right">
                                        <button className="btn btn-default" onClick={this.handleDownload.bind(this)} style={{ marginBottom: 10, padding: "3px 6px", fontSize: 14 }}><i className="fa fa-download" aria-hidden="true" style={{ marginRight: 10 }}></i>Download as PDF</button>
                                    </div>
                                    <h5>
                                        Transfer History
                                        </h5>
                                        {this.state.quickLoad && <Loader />}
                                    {this.state.loader ? <div><Loader /></div> :
                                    
                                        cardState.status === 200 && cardInUse.length !== 0 && cardInUse.cardStatus === "Inactive/Blocked Card" ? <div className="text-center" style={{ marginTop: "20px" }}>Selected Card is Inactive/Blocked.</div> : transHistory.status === 200 ?
                                            <table className="table table-striped" id="TransferdivPrint">
                                                <thead>
                                                    <tr style={{ fontSize: "13px" }}>
                                                        <th className="nopaddingleft">Transfer ID	</th>
                                                        <th>Account(From)</th>
                                                        <th>Account(To)</th>
                                                        <th className="nopaddingright" >Amount</th>
                                                        <th>Transfer Date</th>
                                                        <th>Status</th>
                                                        <th>Options</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                              
                                                    {transHistory.body.transactions.length !== 0 && transHistory.body.transactions.map((value, i) =>
                                                        <tr style={{ fontSize: "13px" }} key={i}>
                                                            <td>{transHistory.body.transactions[i].transactionId}</td>
                                                            <td>{transHistory.body.transactions[i].fromAccount} {}
                                                                {transHistory.body.transactions[i].lastFourDigitsCardNumber} </td>
                                                            <td>{transHistory.body.transactions[i].toAccount}  </td>
                                                            <td>$ {transHistory.body.transactions[i].amount}</td>
                                                            <td>{transHistory.body.transactions[i].transferDate}</td>
                                                            <td>{transHistory.body.transactions[i].status}</td>
                                                            <td className="pseudolink" ><a ><span aria-hidden="true" data-toggle="modal" data-target="#editview" onClick={(e) => { this.handleView(transHistory.body.transactions[i]) }} style={{ color: "#333", cursor: "pointer" }}> View </span></a> </td>
                                                        </tr>
                                                    )}
                                                    {transHistory.status === 200 && transHistory.body.transactions.length === 0 &&
                                                        <div className="row">
                                                            <span style={{ fontSize: "20px", position: "absolute", left: "295px" }}>
                                                                No Records Found
                                                                 </span>
                                                        </div>}
                                                    {transHistory.status === 200 && transHistory.body.transactions.length === 0 &&
                                                        <div className="row">
                                                            <span style={{ fontSize: "20px", position: "absolute", left: "295px" }}>
                                                                No Records Found
                                                                 </span>
                                                        </div>}
                                                </tbody>
                                            </table>
                                            : <Loader />}

                                    {transHistory.status === 500 && this.state.loader === false &&
                                        <div className="row">
                                            <span style={{ fontSize: "20px", position: "absolute", left: "295px" }}>
                                                No Records Found
                                                </span>
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div >
        );
    }
}
TransferHistory.defaultProps = {
    cardState: {
        status: 600
    },
    transHistory: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TransferHistory);


// WEBPACK FOOTER //
// ./src/components/transferfunds/transferhistory.jsx